"use strict";
function constant(value) {
    return function () {
        return value;
    };
}
module.exports = constant;
//# sourceMappingURL=constant.js.map